import React, { useEffect, useState } from 'react'
import s from './InitialsPicker.module.scss'
import cx from 'classnames'
import EventPubSub from 'scripts/util/EventPubSub'
import AudioManager from 'scripts/util/AudioManager'

const letters = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z", "-", " "]

InitialsPicker.defaultProps = {

};

export default function InitialsPicker({ className, onUpdate, selected }) {
  const [initials, setInitials] = useState({
    first: 'A',
    second: 'A',
    third: 'A',
  })

  useEffect(() => {
    if (onUpdate) {
      onUpdate(`${initials.first}${initials.second}${initials.third}`)
    }
  }, [onUpdate, initials.first, initials.second, initials.third])

  useEffect(() => {
    EventPubSub.subscribe('incrementInitial', incrementLetter)
    return () => {
      EventPubSub.unsubscribe('incrementInitial', incrementLetter)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function incrementLetter(key, value) {
    if (!initials[key]) {
      return  
    }
    AudioManager.playSound('uiSelect')
    setInitials({
      ...initials,
      [key]: getNextLetter(key, value),
    })
  }

  function getNextLetter(key, value) {
    const index = letters.indexOf(initials[key])
    const newIndex = (index + value + letters.length) % letters.length

    return letters[newIndex]
  }

  const initialPicker = (key) => {
    return (
    <div className={cx(s.initialPicker, {[s.selected]: selected === key})} key={key}>
      {/* UP arrow */}
      <div className={s.up} onClick={() => incrementLetter(key, 1)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="26.973" height="23" viewBox="0 0 26.973 23">
          <path id="Polygon_1" data-name="Polygon 1" d="M13.487,0,26.973,23H0Z"/>
        </svg>
      </div>
      <div className={s.initialWrapper}>
        <h2 className={s.initial}>{ initials[key] }</h2>
      </div>
      {/* DOWN arrow */}
      <div className={s.down} onClick={() => incrementLetter(key, -1)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="26.973" height="23" viewBox="0 0 26.973 23">
          <path id="Polygon_1" data-name="Polygon 1" d="M13.487,0,26.973,23H0Z"/>
        </svg>
      </div>
    </div>
    )
  }
  
  return (
    <div className={cx(s.InitialsPicker, className)}>
      {
        Object.keys(initials).map(key => (
          initialPicker(key)
        ))
      }
    </div>
  );
}


